export interface PurchaseAlert {
  name: string
  city: string
  country: string
  minutesAgo: number
}

export const purchaseAlerts: PurchaseAlert[] = [
  { name: 'James W.', city: 'Manchester', country: 'United Kingdom', minutesAgo: 2 },
  { name: 'Ethan R.', city: 'Toronto', country: 'Canada', minutesAgo: 4 },
  { name: 'Michael D.', city: 'Houston', country: 'United States', minutesAgo: 6 },
  { name: 'Liam C.', city: 'Melbourne', country: 'Australia', minutesAgo: 3 },
  { name: 'Craig S.', city: 'Glasgow', country: 'United Kingdom', minutesAgo: 8 },
  { name: 'Noah B.', city: 'Vancouver', country: 'Canada', minutesAgo: 5 },
  { name: 'Anthony P.', city: 'Phoenix', country: 'United States', minutesAgo: 7 },
  { name: 'Jack T.', city: 'Brisbane', country: 'Australia', minutesAgo: 9 },
  { name: 'Owen H.', city: 'Leeds', country: 'United Kingdom', minutesAgo: 11 },
  { name: 'Lucas F.', city: 'Calgary', country: 'Canada', minutesAgo: 12 },
  { name: 'Brandon K.', city: 'Denver', country: 'United States', minutesAgo: 10 },
  { name: 'Cooper N.', city: 'Perth', country: 'Australia', minutesAgo: 14 },
]
